import React, { Component } from 'react'
import Select from 'react-select'

class StoreTicketStatus extends Component {
    constructor() {
        super()

        if(window.location.pathname==="/dashboard/storestickets/list"){
            this.state = {
                ticketList:[ {"label":"NEW","value":"NEW"},{"label":"ASSIGNED","value":"ASSIGNED"},{"label":"HOLD","value":"HOLD"},{"label":"CLOSED","value":"CLOSED"}]
            }
        }else{
            this.state = {
                    ticketList:[ {"label":"HOLD","value":"HOLD"},{"label":"CLOSED","value":"CLOSED"}]
            }
        }
        
        this.isComponentStillMounted = true
    }

   

    componentWillUnmount() {
        this.isComponentStillMounted = false
    }

    

    render() {
       return (
            <div>
                <Select
                value={this.props.selectedValue}
                options={this.state.ticketList}
                placeholder="Select status"
                onChange={(e) => { (e) ? this.props.storeTicketStatusChange(e) : this.props.storeTicketStatusChange([])}}
                />
            </div>
        )
    }
}

export default StoreTicketStatus


// WEBPACK FOOTER //
// ./src/modules/Stores/Components/DropDowns/StoreTicketStatus.js